<template>
	<div class="payment-product">
		<h3 v-if="oid!==undefined">주문 정보</h3>
		<h3 v-else>제품 정보</h3>
		<div class="product-list">
			<template v-if="this.$route.query.cidxs !== undefined || oid !== undefined">
				<template v-for="item in producList">
					<div class="row-box" v-if="item.count > 0">
						<div class="product-thumb">
							<img v-if="item.goodsVO.thumbnail !== null" :src="APIs.SHOP_FILE_SHOW + item.goodsVO.thumbIdx" alt="">
							<img v-else src="public/ssflex/assets/img/common/img_thumb.svg">
						</div>
						<div class="product-name">
							<a :href='"/app/shop/goods/" + item.gid'>{{item.goodsVO.title}}</a>
							<div v-if="item.optionSummary" class="product-options">{{ item.optionSummary }}</div>
							<br><span class="unit" v-show="item.goodsVO.isVat">*부가세포함</span>
						</div>
						<div class="product-quantity">x{{item.count | currency}}</div>
						<div class="product-price">
							{{ ((item.goodsVO.basePrice + (item.optionPriceSum || 0)) * item.count) | currency }} <span class="unit">원</span>
						</div>
					</div>
				</template>
			</template>
			<template v-else-if="this.$route.query.gidx !== undefined">
				<div class="row-box">
					<div class="product-thumb">
						<img v-if="producList[0].thumbnail !== null" :src="APIs.SHOP_FILE_SHOW + producList[0].thumbIdx" alt="">
						<img v-else src="public/ssflex/assets/img/common/img_thumb.svg">
					</div>
					<div class="product-name">
						<a :href='"/app/shop/goods/" + producList[0].gid'>{{producList[0].title}}</a>
						<div v-if="selectedOptionDetails && selectedOptionDetails.length" class="product-options">
							<span v-for="d in selectedOptionDetails" :key="d.id" class="option-item">{{ d.optionName }}(+{{ d.optionPrice }}원)</span>
						</div>
					</div>
					<div class="product-quantity">x{{ this.$route.query.count | currency }}</div>
					<div class="product-price">
						{{ totalCost | currency }} <span class="unit">원</span>
					</div>
				</div>
			</template>
		</div>
		<div v-if="totalCost!==undefined" class="product-total">
			<span class="label">총 상품 금액</span>
			<span class="price">{{totalCost | currency}}<span class="unit"> 원</span></span>
		</div>
	</div>
</template>

<script>
export default {
	name: "orderProduct",
	props: {
		producList: Array,
		totalCost: Number,
		oid: String,
		selectedOptionDetails: { type: Array, default: () => [] }
	},
	created() {

	},
	methods: {

	}
}
</script>

<style scoped>
.product-options { margin-top: 4px; font-size: 12px; color: #666; }
.product-options .option-item { margin-right: 6px; }
</style>
